import React, { useState } from "react";
import ChildrenModal from "component/dc/modal/ChildrenModal";
import useCurrentDealStore from "store/DealStore";
import shallow from "zustand/shallow";
import MoneyDownTable from "./MoneyDownTable";
import { MoneyDownForm } from "./MoneyDownForm";

const MoneyDownModal = ({ modal, toggle }) => {
	const { downPayments } = useCurrentDealStore(
		(state) => ({
			downPayments: state.downPayments,
		}),
		shallow
	);
	const [currentIndex, setCurrentIndex] = useState(downPayments?.length);
	const [open, setOpen] = useState(false);

	const toggleOpen = () => setOpen(!open);

	return (
		<ChildrenModal
			modal={modal}
			toggle={toggle}
			modalTitle="Down Payments"
			size="lg"
			children={
				<>
					<ChildrenModal
						modal={open}
						toggle={toggleOpen}
						size="lg"
						children={
							<MoneyDownForm
								currentIndex={currentIndex}
								setCurrentIndex={setCurrentIndex}
								toggle={toggleOpen}
							/>
						}
					/>
					<MoneyDownTable
						setCurrentIndex={setCurrentIndex}
						toggle={toggleOpen}
					/>
				</>
			}
		/>
	);
};

export default MoneyDownModal;
